export const VEHICLE = 8;
export const TANK = 14;
export const EMPLOYEE = 3;
